export const useLocalStorage = () => {
  function setData(key: string, data: any) {
    if (data) localStorage.setItem(key, JSON.stringify(data));
  }

  function getData(key: string) {
    const data = localStorage.getItem(key) || "";

    if (data !== "undefined" && data !== null && data !== "") {
      return JSON.parse(data);
    }
  }

  return { getData, setData };
};
